// extracted by mini-css-extract-plugin
export default {"statusContainer":"style_statusContainer__JzZoH","icon":"style_icon__eW+tx","statusLabel":"style_statusLabel__zvGJm"};